import { useNavigate } from 'react-router-dom';
import './style.css';
import { ImageSize, useResponsiveImage } from '@/utils/useResponsiveImage';
import classNames from 'classnames';
import { CenteredCoverImage } from '../CenteredCoverImage';

interface CardProps {
  title: string;
  tags?: React.ReactNode;
  description: string;
  author: string;
  link?: string;
  button?: React.ReactNode;
  imageSize?: ImageSize;
  noImage?: boolean;
  image?: {
    url: string;
    alternativeText: string;
  };
}
export default function Card({
  title,
  tags,
  description,
  author,
  image,
  noImage = false,
  link,
  button,
  imageSize = 'medium',
}: CardProps) {
  const navigate = useNavigate();
  const { src: imageSrc } = useResponsiveImage(image, imageSize);

  return (
    <div
      key={title}
      role="button"
      tabIndex={0}
      className={classNames(
        `card group h-full overflow-hidden rounded-2xl border border-primary-500 bg-white ${link ? 'cursor-pointer hover:border-primary-600' : ' cursor-default'}`,
        {
          'min-h-[402px] lg:max-w-[414px]': !noImage,
        },
      )}
      onClick={() => {
        if (link) {
          navigate(link);
        }
      }}>
      {/* {!noImage && imageSrc && (
        <div className="lg:spect-auto aspect-video w-full overflow-hidden bg-cover bg-center duration-500 ease-linear">
          <div
            className={`h-full w-full bg-cover bg-center duration-500 ease-linear ${link ? 'group-hover:scale-110' : ''}`}
            style={{
              backgroundImage: `url('${imageSrc}')`,
              transformOrigin: 'center',
            }}
          />
        </div>
      )} */}

      {!noImage && imageSrc && (
        <CenteredCoverImage
          src={imageSrc}
          alt={image?.alternativeText || ''}
          className={`duration-500 ease-linear ${link ? 'group-hover:scale-110' : ''}`}
        />
      )}

      <div className="rows-span-1 flex flex-col items-start gap-1 p-5">
        {tags}
        <div>
          <p className={`font-larken text-sh-22-28 ${link ? 'group-hover:text-primary-600' : ''}`}>{title}</p>
          <p className="line-clamp-4 text-sh-xxs">{description}</p>
          {author && <p className="text-sh-xxxs text-sh-grey-500">By {author}</p>}
        </div>
        {button && <div className="rows-span-1 mt-sh-15 flex flex-col items-start gap-1">{button}</div>}
      </div>
    </div>
  );
}
